import { render, staticRenderFns } from "./AgendaComponent.vue?vue&type=template&id=12f08c6b&"
import script from "./AgendaComponent.vue?vue&type=script&lang=js&"
export * from "./AgendaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports